import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, { FunctionComponent, useRef, useState } from 'react';
import {useTranslation} from 'react-i18next';
import cn from 'classnames';

import './TestEvents.scss';
import {RunGroupID, ServerEndpoint, SSEEventType, SSEStatus, TestStatus} from 'enums';
import {ISSEEvent, ISSEEventEndpointRequest, ISSEEventEndpointResponse, ISSEEventError, ISSEEventGotReboot, ISSEEventInfo, ISSEEventNeedReboot, ISSEEventRunGroupStart, ISSEEventRunGroupStop, ISSEEventRunStart, ISSEEventRunStop, ISSEEventTestState} from 'interfaces';
import {TestEvent, ISSEEventListItem} from './TestEvent';

interface ITestEventsProps {
    sseStatus: SSEStatus,
    events: ISSEEvent[],
    isWaitingOnReboot: boolean,
}

export const TestEvents: FunctionComponent<ITestEventsProps> = ({sseStatus, events, isWaitingOnReboot}) => {
    const {t, i18n} = useTranslation();
    const curIdRef = useRef(1);

    // We're adding a few props to the events, like an id and props for expanding.
    const mappedEvents = events as ISSEEventListItem[];

    // Assign each event an id because react list items need keys.
    for (const e of mappedEvents) {
        if (!e.id) {
            e.id = curIdRef.current;
            curIdRef.current++;
        }
    }

    let content: JSX.Element | JSX.Element[];
    if (mappedEvents && mappedEvents.length > 0) {
        // If we have events, show them
        content = mappedEvents.map((e) => (
            <TestEvent event={e} key={e.id} />
        ))
    } else if (sseStatus === SSEStatus.Connecting || sseStatus === SSEStatus.WaitingForReplay) {
        // We're trying to connect
        content = (
            <div className="testEvent">
                {t('tests.serverEventsConnecting')}
            </div>
        )
    } else if (sseStatus === SSEStatus.Error) {
        // Error
        content = (
            <div className="testEvent">
                {t('tests.serverEventsError')}
            </div>
        )
    } else {
        // Not connected
        content = (
            <div className="testEvent">
                {t('tests.serverEventsNotConnected')}
            </div>
        )
    }

    return (<>
        <div className={cn({
            testEvents: true,
            testEvents_showingReboot: isWaitingOnReboot,
        })}>
            {content}
        </div>
        {isWaitingOnReboot && (
            <div className="tests_rebootMessage">
                {t('tests.events.rebootMessage')}
            </div>
        )}
    </>);
}